import MD5 from "crypto-js/md5";
import { getResFromJWTToken } from "./decodeJWTRes";
import { handlePayment } from "../services/paymentService";

function uniqidWithHash(userId: string, courseId: string, prefix = "") {
  const sec = Date.now() * 1000 + Math.floor(Math.random() * 1000);
  const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
  const hash = MD5(`${userId}_${courseId}`).toString();
  return `${prefix}${id}_${hash}`;
}

export const createPayment = async (
  data: any,
  token: string,
  setModalText: any,
  setIsModalOpen: any
) => {
  if (!token) {
    setModalText("Please log in to enroll in the course");
    setIsModalOpen(true);
    return;
  }

  const userData: any = getResFromJWTToken(token);
  const userId = userData?.data?.user?.id ?? 0;
  const amount = data.coursePrice?.regularPrice || 499;
  const currency = "INR";
  const uniqueId = uniqidWithHash(userId, data?.id);

  const notes = {
    is_learndash: true,
    learndash_version: "4.15.0",
    post_id: Number(data?.id),
    user_id: Number(userId),
    operation_id: uniqueId,
    courseTitle: data?.title,
    authorName: data?.authorName,
  };

  try {
    const orderData: any = await handlePayment({ amount, currency, notes });

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: orderData.data?.amount,
      order_id: orderData.data?.id,
      currency: currency,
      name: data?.title,
      image: data?.featuredImage,
      description: "Enroll in the course",
      handler: (response: any) => {
        setModalText("Payment successful!");
        setIsModalOpen(true);
      },
      theme: {
        color: "#F37254",
      },
      notes: JSON.stringify(notes),
    };

    const rzp = new (window as any).Razorpay(options);
    rzp.open();
  } catch (error) {
    setModalText(
      "There was an error processing your payment. Please try again."
    );
    setIsModalOpen(true);
  }
};
